export default "__VITE_ASSET__d93889c5__"